// src/pages/StaffViewModal.jsx
import React from "react";
import { X, Pencil } from "lucide-react";
import { clsx } from "clsx";

export function StaffViewModal({ staff, onClose, onEdit }) {
  if (!staff) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-xl rounded-2xl bg-white shadow-2xl animate-in fade-in zoom-in-95">
        
        <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
          <h3 className="font-bold text-slate-800">수행요원 상세 조회</h3>
          <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100"><X className="h-5 w-5" /></button>
        </div>

        <div className="p-6 space-y-4">
          <div className="flex items-center gap-4 rounded-xl bg-slate-50 border border-slate-100 p-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-orange-500 text-white text-2xl font-bold shadow-md shrink-0">
              {staff.staffNm?.[0] || 'S'}
            </div>
            <div>
              <p className="text-lg font-bold text-slate-800">{staff.staffNm}</p>
              <div className="flex items-center gap-2 mt-1">
                <span className="rounded-full bg-teal-50 text-teal-700 px-2.5 py-0.5 text-xs font-medium">{staff.positionNm || '-'}</span>
                <span className={clsx("rounded-full px-2.5 py-0.5 text-xs font-semibold", staff.useYn === "Y" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-600")}>
                  {staff.useYn === "Y" ? "사용 중" : "미사용 (퇴사)"}
                </span>
              </div>
            </div>
          </div>

          <div className="divide-y divide-slate-100 rounded-xl border border-slate-200 overflow-hidden">
            {[
              { label: "사번/ID", value: staff.staffId, mono: true },
              { label: "소속 부서", value: staff.deptNm || "-" },
              { label: "연락처", value: staff.telNo || "-" },
              { label: "이메일", value: staff.email || "-" },
              { label: "등록자", value: staff.regId || "-", mono: true },
              { label: "등록 일시", value: staff.regDtm || "-" },
              { label: "수정자", value: staff.modId || "-", mono: true },
              { label: "수정 일시", value: staff.modDtm || "-" }
            ].map(({ label, value, mono }) => (
              <div key={label} className="flex items-center px-4 py-3 gap-4 hover:bg-slate-50">
                <span className="w-24 shrink-0 text-xs font-semibold text-slate-400">{label}</span>
                <span className={clsx("text-sm text-slate-800", mono && "font-mono")}>{value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-end gap-3 border-t border-slate-200 px-6 py-4 bg-slate-50 rounded-b-2xl">
          <button onClick={onClose} className="h-10 px-5 rounded-lg border bg-white text-sm">닫기</button>
          <button onClick={onEdit} className="h-10 flex items-center gap-2 px-5 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700">
            <Pencil className="h-4 w-4" /> 수정
          </button>
        </div>
      </div>
    </div>
  );
}